/**
 * formatTime formats time with provided timeFormat string. Uses toStringEx polyfill.
 * @param date {Date} date to be formatted
 * @param timeFormat {string} time formatting string
 * @returns formatted time {String} string representation of the time
 */
export function formatTime(date, timeFormat) {
    var formattedTime = date.toStringEx(timeFormat);
    return formattedTime;
}
//# sourceMappingURL=CurrentTimeFormatter.js.map